<template lang="pug">
    .component-transaction-action-buttons(v-if="entity")
        //ul.dropdown.menu(v-if="item", data-dropdown-menu='', v-f="")
            li
                a(href='#Item-1') Action
                ul.menu
                    li
                        transaction-reveal-refund(:refundFields="refundFields", :transaction="entity", @refundTransaction="refund")
        //.dropdown-buttons(v-else)
            transaction-reveal-refund(v-if="entity.status ==='SUCCESS'", :buttons="true", :transaction="entity", :refundFields="refundFields", @refundTransaction="refund")
</template>
<script type="text/babel">
    import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
    import MaggieHelper from "src/maggieHelper"
    import TransactionRevealRefund from "./reveal/TransactionRevealRefund";
    import GatewayUrlHelper from 'src/lib/helpers/gatewayUrlHelper'

    export default {
        name: "TransactionActionButtons",
        components: {
            TransactionRevealRefund,
        },
        data() {
            return {
                entity: null,
                refundFields: {
                    amount: null
                }
            }
        },
        created() {
            if (!this.transaction) {
                KeplerBackofficeSdk.transactions.select(this.$route.params.id).get((item) => {
                    this.entity = item
                })

            } else {
                this.entity = this.transaction
            }
        },
        methods: {
            refund() {
                MaggieHelper.showPreloader();

                KeplerBackofficeSdk.transactions.select(this.entity).refund(this.refundFields, (response) => {
                    this.entity = response;
                    MaggieHelper.hidePreloader()
                }, (response) => {
                    MaggieHelper.notification('refund-esit', response, 'error');
                    MaggieHelper.hidePreloader()
                })
            },
            viewOnGateway() {
                var url = GatewayUrlHelper.transactionUrl(this.entity.payment_method_provider, this.entity.transaction_uid);
                window.open(url, '_blank')
            }
        },
        props: ['transaction', 'item']
    }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// TransactionButtons.vue?75d443b6